/**
 * Composant Navbar
 * Gère le burger menu et l'effet affix au scroll
 *
 * Sélecteurs sémantiques : .ui-navbar-burger
 */

import { logger } from '../../core/base.js';

/**
 * Initialise le burger menu de la navbar
 */
function initBurgerMenu() {
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.ui-navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach(el => {
            const navbar = el.closest('.ui-navbar, .navbar');
            let $target = null;

            if (el.dataset.target) {
                $target = document.getElementById(el.dataset.target);
            }

            if (!$target && navbar) {
                $target = navbar.querySelector('.ui-navbar-menu, .navbar-menu');
            }

            if ($target && !$target.id) {
                $target.id = `ui-navbar-menu-${Math.random().toString(36).slice(2, 10)}`;
            }

            if ($target?.id && !el.getAttribute('aria-controls')) {
                el.setAttribute('aria-controls', $target.id);
            }

            const closeMenu = () => {
                el.classList.remove('is-active');
                $target?.classList.remove('is-active');
                el.setAttribute('aria-expanded', 'false');
            };
            navbar?.addEventListener('keydown', event => {
                if (event.key === 'Escape' && el.classList.contains('is-active')) {
                    closeMenu();
                    el.focus();
                }
            });
            $target?.addEventListener('click', event => {
                if (event.target.closest('a[href]')) closeMenu();
            });

            el.addEventListener('click', () => {
                if (!$target) {
                    logger.warn('Navbar burger clicked without matching menu target');
                    return;
                }

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
                el.setAttribute('aria-expanded', String(el.classList.contains('is-active')));
            });
        });

        logger.debug(`Navbar burger menu initialized (${$navbarBurgers.length} burgers)`);
    }
}

/**
 * Initialise l'effet affix (navbar sticky avec effet au scroll)
 */
function initAffixEffect() {
    const html = document.querySelector('html');

    // État initial
    if (window.scrollY > 0) {
        html.classList.add('affix');
    }

    // Écoute du scroll
    window.addEventListener('scroll', function (event) {
        if (window.scrollY > 0) {
            html.classList.add('affix');
        } else {
            html.classList.remove('affix');
        }
    });

    logger.debug('Navbar affix effect initialized');
}

/**
 * Initialisation du composant navbar
 */
export function initNavbar() {
    initBurgerMenu();
    initAffixEffect();
}

// Auto-initialisation au chargement du DOM
document.addEventListener('DOMContentLoaded', initNavbar);
